/**
 * Analysis Settings - Analiz ayarları paneli
 * 
 * Features:
 * - Analysis method selection (Bayesian, Z-Test, Chi-Squared)
 * - Confidence level settings
 * - Test duration configuration
 * - Traffic settings
 * - Revenue calculations setup
 */

import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Box
} from '@mui/material';
import {
  Calculate as CalculateIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';

const AnalysisSettings = ({
  postTestSettings,
  loading,
  onSettingsChange,
  onCalculate,
  onClear
}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Analiz Ayarları
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Analiz Yöntemi</InputLabel>
              <Select
                value={postTestSettings.analysisMethod}
                label="Analiz Yöntemi"
                onChange={(e) => onSettingsChange('analysisMethod', e.target.value)}
              >
                <MenuItem value="bayesian">Bayesian Analysis</MenuItem>
                <MenuItem value="ztest">Z-Test</MenuItem>
                <MenuItem value="chisquared">Chi-Squared Test</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Güven Seviyesi</InputLabel>
              <Select
                value={postTestSettings.confidenceLevel}
                label="Güven Seviyesi"
                onChange={(e) => onSettingsChange('confidenceLevel', e.target.value)}
              >
                <MenuItem value={0.90}>90%</MenuItem>
                <MenuItem value={0.95}>95%</MenuItem>
                <MenuItem value={0.99}>99%</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Test Süresi (Gün)"
              type="number"
              value={postTestSettings.testDuration}
              onChange={(e) => onSettingsChange('testDuration', parseInt(e.target.value) || 0)}
              inputProps={{ min: 1 }}
              helperText="Test ne kadar süre çalıştı?"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Günlük Trafik"
              type="number"
              value={postTestSettings.dailyTraffic}
              onChange={(e) => onSettingsChange('dailyTraffic', parseInt(e.target.value) || 0)}
              inputProps={{ min: 100 }}
              helperText="Günlük ziyaretçi sayısı"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Trafik Dağılımı (%)"
              type="number"
              value={postTestSettings.trafficSplit}
              onChange={(e) => onSettingsChange('trafficSplit', parseInt(e.target.value) || 0)}
              inputProps={{ min: 10, max: 90 }}
              helperText="Teste yönlendirilen trafik yüzdesi"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Ortalama Sipariş Değeri (₺)"
              type="number"
              value={postTestSettings.averageOrderValue}
              onChange={(e) => onSettingsChange('averageOrderValue', parseFloat(e.target.value) || 0)}
              inputProps={{ min: 0, step: 0.01 }}
              helperText="Gelir hesaplamaları için (opsiyonel)"
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            onClick={onCalculate}
            disabled={loading}
            startIcon={<CalculateIcon />}
            fullWidth
          >
            {loading ? 'Hesaplanıyor...' : 'Analiz Et'}
          </Button>
          
          <Button
            variant="outlined"
            onClick={onClear}
            startIcon={<RefreshIcon />}
            fullWidth
          >
            Temizle
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AnalysisSettings; 